export const dashboardTranslationFr = {
    dashboard: {
        accountNumber: 'N° client : ',
        bill: 'Factures',
        billLabel: 'Consultez, gérez, payez vos factures en ligne.',
        billOld: 'Factures',
        bills: {
            billText: 'Facture du ',
            button: {
                paidYourBill: 'Gérer et payer vos factures',
                soshLabel: 'Gérer sur Sosh.fr',
                orangeLabel: 'Gérer sur Orange.fr',
                billPageLinkUrl: {
                    inApp: 'facture-paiement/{{cid}}',
                },
                mixteLink: {
                    inApp: 'factures-paiement',
                },
            },
            delegation: 'Titulaire : ',
            noBillText: 'Pas de facture disponible',
            title: 'Factures',
            whoUseContract: {
                label: 'Qui utilise ce contrat ?',
                link: {
                    inApp: 'compte/association-contrat/{{cid}}',
                },
                linkParam: {
                    queryParams: {
                        return: 'factures-paiement',
                    },
                },
            },
        },
        conso: {
            routes: {
                extraBalance: 'conso/{{cid}}/details/{{equipmentId}}/{{familyCode}}/{{bundleCode}}',
                basic: 'conso/{{cid}}/equipement/{{idSuiviConso}}',
                basicFixe: 'conso/{{cid}}/equipement/{{equipmentId}}',
            },
        },
        contractsAndOptions: {
            title: 'Contrats et options',
            subTitleMultiContracts: 'Vos contrats',
            subTitleSingleContract: 'Votre contrat',
            delegation: 'Titulaire : ',
            whoUseContract: {
                label: 'Qui utilise ce contrat ?',
                link: {
                    inApp: 'compte/association-contrat/{{cid}}',
                },
                linkParam: {
                    queryParams: {
                        return: 'contrats-options',
                    },
                },
            },
            button: {
                addThisContract: 'Ajouter ce contrat',
                offerAndOptions: {
                    label: 'Gérer votre offre et vos options',
                    soshLabel: 'Gérer sur Sosh.fr',
                    orangeLabel: 'Gérer sur Orange.fr',
                    offerAndOptionLink: {
                        inApp: 'offre-options/{{cid}}',
                    },
                    landLineLink: {
                        nec: '/?page=mon-offre&idContrat={{cid}}',
                    },
                    mixteLink: {
                        inApp: 'contrats-options',
                    },
                },
            },
            landLineMessage:
                'Pour gérer ce contrat, rendez-vous dans votre Espace client orange.fr depuis un ordinateur.',
            familyAdvantages: {
                label: 'Avantages famille',
                subLabel: 'Retrouvez vos avantages client Orange à partager avec vos proches',
                linkLabel: 'En savoir plus',
                link: {
                    inApp: 'offre-options/avantages-clients-orange/{{cid}}',
                },
            },
            manageContract: {
                title: "Consulter d'autres contrats",
                subTitle: 'Gérer des contrats déjà souscrits',
                text: "Vous pouvez gérer d'autres contrats, le forfait souscrit pour votre enfant, celui d'un proche. Retrouvez-les dans votre Espace client.",
                addContract: {
                    button: 'Rattacher un contrat',
                    link: {
                        web: {
                            nec: '/?cont=AJOUT',
                        },
                        webapp: {
                            nec: '/?page=redirect-cadap',
                        },
                    },
                    ecmLink: {
                        inApp: 'rattacher-un-contrat',
                    },
                },
                vimContract: {
                    button: 'Rattacher un contrat',
                    link: {
                        web: {
                            nec: '/?page=verif-ident-titulaire',
                        },
                        webapp: {
                            nec: '/?page=redirect-cadap',
                        },
                    },
                },
                removeContract: {
                    button: 'Retirer un contrat',
                    link: {
                        inApp: 'retirer-contrat',
                    },
                },
            },
            inprogressContract: {
                text: "Ce contrat est en cours d'installation et sera bientôt disponible.",
                labelLink: 'Suivre votre commande',
                labelOrangeLink: 'Suivre votre commande sur Orange.fr',
                orangeLink: {
                    browser: 'https://suivi.orange.fr',
                },
                labelSoshLink: 'Suivre votre commande sur Sosh.fr',
                soshLink: {
                    browser: 'https://suivi.sosh.fr',
                },
            },
            suggestedContract: {
                titleMultiContracts: 'Ces contrats semblent vous appartenir',
                titleSingleContract: 'Ce contrat semble vous appartenir',
                subTitleMultiContracts: 'Gérez-les en les ajoutant à votre Espace client.',
                subTitleSingleContract: 'Gérez-le en les ajoutant à votre Espace client.',
                addContract: {
                    button: 'Rattacher un contrat',
                    link: {
                        web: {
                            nec: '/?cont=AJOUT&push=1&idContract={{cid}}#idContract={{cid}}',
                        },
                        webapp: {
                            nec: '/?page=redirect-cadap',
                        },
                    },
                    ecmLink: {
                        inApp: 'rattacher-un-contrat/{{cid}}',
                    },
                },
                removeContract: {
                    button: 'Ne plus afficher',
                    link: {
                        inApp: 'retirer-contrat/{{cid}}',
                    },
                },
            },
            isKoContract: {
                total: 'Ce contrat est temporairement indisponible.',
                partial: 'Certaines informations sont indisponibles.',
            },
            suspendedContract: {
                lostAndStolen: {
                    title: 'Votre ligne {{mobileNumber}} est suspendue',
                    text: 'Dès que votre ligne sera réactivée, vous pourrez à nouveau accéder à toutes les fonctionnalités.',
                    button: {
                        label: 'Réactiver votre ligne',
                        link: {
                            inApp: '/equipements/{{cid}}/31001/retablir-votre-ligne',
                        },
                    },
                },
                nonPaymentMobile: {
                    title: 'Vos services sont suspendus pour impayé',
                    text: "Régularisez l'impayé pour rétablir immédiatement vos services.",
                    button: {
                        label: 'Payer votre facture',
                        link: {
                            inApp: 'facture-paiement/{{cid}}',
                        },
                    },
                },
                nonPaymentInternet: {
                    title: 'Vos services vont bientôt être suspendus pour impayé',
                    text: "Régularisez immédiatement l'impayé pour éviter cette suspension.",
                    button: {
                        label: 'Payer votre facture',
                        link: {
                            inApp: 'facture-paiement/{{cid}}',
                        },
                    },
                },
            },
            multiContract: {
                button: 'Accéder au site internet',
                obs: {
                    message: ["Pour gérer ce contrat, utilisez l'Espace client Business Lounge."],
                    link: {
                        browser: 'https://businesslounge.orange.fr',
                    },
                },
                pro: {
                    message: ["Pour gérer ce contrat, utilisez l'Espace client Orange Pro."],
                    link: {
                        browser: 'https://espaceclientpro.orange.fr/',
                    },
                },
                parnasse: {
                    message: [
                        "En tant que Membre du cercle Parnasse, vous bénéficiez d'un desk privilégié joignable au +33 (0) 969 390 380.",
                        "Pour gérer ce contrat, vous pouvez aussi utiliser l'Espace client Parnasse.",
                    ],
                    link: {
                        browser: 'https://membre.parnasse.fr/',
                    },
                    eSimLabel: 'Activer votre eSIM',
                    eSimLink: {
                        inApp: 'equipements/{{cid}}/31001/esim',
                    },
                },
            },
            protectedHouse: {
                suspendedOfferName: 'Ancien contrat télésurveillance',
                detail: 'Télésurveillance',
                button: 'Accéder au site web',
                message: [
                    'Pour gérer ce contrat, accédez au site web Maison Protégée en vous identifiant avec votre numéro de contrat.',
                ],
                link: {
                    browser: 'https://maisonprotegee.orange.fr',
                },
            },
        },
        crossroadItem: {
            bills: {
                icon: 'icon-Invoice-euro',
                label: 'Factures',
                link: {
                    inApp: 'facture-paiement/{{cid}}',
                },
            },
            offers: {
                icon: 'icon-Package-services',
                label: 'Offre et options',
                text: 'Service accessible uniquement dans votre espace client orange.fr depuis un ordinateur',
                link: {
                    inApp: 'offre-options/{{cid}}',
                },
                landLineLink: {
                    inApp: 'equipements/{{cid}}/mon-offre-ligne-fixe',
                },
            },
        },
        deviceSIM: {
            extraBalance: {
                restText: 'Hors forfait : ',
                restTextNull: 'Hors forfait : 0,00 €',
                consumption: 'Voir le détail',
            },
            error: {
                consumption: 'Suivi conso temporairement  indisponible',
            },
            gaugeInfoColor: '#f4f4f4',
            internetMobile: {
                restText: 'Reste : ',
                internetReducedText: 'Internet mobile : débit réduit',
                internetExhaustedText: 'Internet mobile : crédit épuisé',
                internetUnlimitedText: 'Internet mobile : illimité',
                exhaustedText: 'Crédit épuisé',
                freeBies: 'Crédit complémentaire : reste ',
                exhaustedFreeBies: 'Crédit complémentaire : épuisé',
                prePaidRestText: 'Crédit rechargé : reste ',
                prePaidExhaustedText: 'Crédit rechargé : épuisé',
                topUp: 'Compte rechargeable : ',
                consumption: 'Suivi conso',
            },
        },
        deviceHome: {
            consumption: 'Suivi conso',
            cosnumptionText: 'Communications payantes : ',
            empty: 'Crédit épuisé',
            error: 'Suivi conso temporairement  indisponible',
            exhaustedText: 'Crédit épuisé',
            restText: 'Reste',
            restTextConsumption: 'Reste : ',
        },
        entertainment: {
            equipmentLinks: {
                '21001': {
                    inApp: 'equipements/{{cid}}/21001/decodeur-tv',
                },
                '21002': {
                    inApp: 'equipements/{{cid}}/21002/decodeur-tv',
                },
                '22001': {
                    inApp: 'equipements/{{cid}}/22001/cle-tv',
                },
            },
        },
        errors: {
            error: {
                title: 'Informations indisponibles.',
                text: 'Veuillez nous excuser pour la gêne occasionnée. Nous vous invitons à réessayer ultérieurement.',
            },
            unavailable: {
                title: 'Le service est momentanément indisponible.',
                text: 'Veuillez nous excuser pour la gêne occasionnée. Nous vous invitons à réessayer ultérieurement.',
            },
        },
        fixeLine:
            'La gestion de votre offre et de vos options est accessible uniquement dans votre espace client orange.fr depuis un ordinateur',
        forbidden: {
            nsru: {
                clientType: 'NSRU',
                title: 'Ajouter un contrat déjà souscrit',
                texts: ["Retrouver toutes vos offres, celle de votre enfant ou d'un proche dans votre espace client."],
                buttons: [
                    {
                        text: 'Rattacher un contrat',
                        link: {
                            references: [
                                {
                                    linkWeb: { nec: '/?cont=AJOUT' },
                                },
                            ],
                        },
                    },
                    {
                        text: 'Changer de compte',
                        link: {
                            browser: 'https://login.orange.fr/?return_url=https://www.orange.fr/portail',
                        },
                    },
                ],
                ecmButtons: [
                    {
                        text: 'Rattacher un contrat',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'rattacher-un-contrat' },
                                },
                            ],
                        },
                    },
                    {
                        text: 'Changer de compte',
                        link: {
                            browser: 'https://login.orange.fr/?return_url=https://www.orange.fr/portail',
                        },
                    },
                ],
            },
            suggested: {
                subTitle: 'Ce contrat semble vous appartenir.',
                texts: ["Gérez-le en l'ajoutant à votre Espace client."],
                buttons: [
                    {
                        text: 'Rattacher ce contrat',
                        link: {
                            references: [
                                {
                                    linkWeb: { nec: '/?cont=AJOUT' },
                                },
                            ],
                        },
                    },
                    {
                        text: 'Ne plus afficher',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'retirer-contrat/{{cid}}' },
                                },
                            ],
                        },
                    },
                ],
                ecmButtons: [
                    {
                        text: 'Rattacher ce contrat',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'rattacher-un-contrat/{{cid}}' },
                                },
                            ],
                        },
                    },
                    {
                        text: 'Ne plus afficher',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'retirer-contrat/{{cid}}' },
                                },
                            ],
                        },
                    },
                ],
            },
            protectedHouse: {
                activeTitle: 'Maison Protégée',
                terminatedTitle: 'Ancien contrat Maison Protégée',
                detail: 'Télésurveillance ',
                texts: [
                    'Pour gérer ce contrat, accédez au site web Maison Protégée en vous identifiant avec votre numéro de contrat.',
                ],
                buttons: [
                    {
                        text: 'Accéder au site web',
                        link: {
                            browser: 'https://maisonprotegee.orange.fr',
                        },
                    },
                ],
            },
            protectedHouseV2: {
                activeTitle: 'Orange Maison Protégée',
                detail: 'Télésurveillance ',
                buttons: [],
                banner: {
                    title: 'Orange Maison Protégée',
                    subtitle:
                        "Retrouvez tout votre univers Orange Maison Protégée sur l'app dédiée : votre système d'alarme, vos factures, le service client…",
                    detail: 'Scannez le QR code avec votre mobile.',
                    detailAriaLabel:
                        "Scannez le qr code avec votre mobile pour ouvrir l'application Orange Maison Protégée ou utilisez le lien suivant depuis votre mobile",
                    logo: {
                        imageSource: 'assets/dashboard/images/maison-protegee-v2.svg',
                        alternativeText: 'maison-protegee-v2',
                    },
                    mobile: {
                        imageSource: 'https://proxymedia.woopic.com/api/v1/images/1202%2FMaisonP_mobile.png',
                        alternativeText: 'maison-protegee-v2-visuel-mobile',
                    },
                    qrCode: {
                        imageSource: 'assets/dashboard/images/maison-protegee-v2-qr-code.svg',
                        url: 'https://r.orange.fr/r/SOmpespcliqrc',
                        alternativeText: 'maison-protegee-v2-qr-code',
                    },
                    buttons: [
                        {
                            imageSource: 'assets/dashboard/images/badge-apple-store.png',
                            alternativeText: 'badge-apple-store',
                            link: {
                                browser: 'https://r.orange.fr/r/SOmpespcliios',
                            },
                            trackedPage: 'accueil_dashboard',
                            trackingArea: 'care_hp_maison',
                            trackingName: 'maison_protegee_v2',
                            hrefLink: 'https://r.orange.fr/r/SOmpespcliios',
                        },
                        {
                            imageSource: 'assets/dashboard/images/badge-play-store.png',
                            alternativeText: 'badge-play-store',
                            link: {
                                browser: 'https://r.orange.fr/r/SOmpespcliand',
                            },
                            trackedPage: 'accueil_dashboard',
                            trackingArea: 'care_hp_maison',
                            trackingName: 'maison_protegee_v2',
                            hrefLink: 'https://r.orange.fr/r/SOmpespcliand',
                        },
                    ],
                },
            },
            sharedServices: {
                activeTitle: 'Services partagés',
                detail: 'Profitez gratuitement des services que les membres de votre foyer vous ont partagés.',
                buttons: [],
                banner: {
                    title: "Application TV d'Orange",
                    subtitle: "Regardez la TV d'Orange sur smartphone et tablette ",
                    logo: {
                        imageSource: 'assets/dashboard/images/App_TV.svg',
                        alternativeText: 'application-tv-orange',
                    },
                    mobile: {
                        imageSource: 'assets/dashboard/images/tv-orange-mobile.svg',
                        alternativeText: 'application-tv-orange-visuel-mobile',
                    },
                    buttons: [
                        {
                            imageSource: 'assets/dashboard/images/badge-apple-store.png',
                            alternativeText: 'badge-apple-store',
                            link: {
                                browser: 'https://apps.apple.com/fr/app/tv-dorange-direct-replay/id308816822',
                            },
                            trackedPage: 'accueil_dashboard',
                            trackingArea: 'care_hp_services_partages_nsru',
                            trackingName: 'services_partages_ios',
                            hrefLink: 'https://apps.apple.com/fr/app/tv-dorange-direct-replay/id308816822',
                        },
                        {
                            imageSource: 'assets/dashboard/images/badge-play-store.png',
                            alternativeText: 'badge-play-store',
                            link: {
                                browser:
                                    'https://play.google.com/store/apps/details?id=com.orange.owtv&hl=fr&gl=US&pli=1',
                            },
                            trackedPage: 'accueil_dashboard',
                            trackingArea: 'care_hp_services_partages_nsru',
                            trackingName: 'services_partages_android',
                            hrefLink: 'https://play.google.com/store/apps/details?id=com.orange.owtv&hl=fr&gl=US&pli=1',
                        },
                    ],
                },
            },
            terminatedContract: {
                buttons: [
                    {
                        text: 'Factures',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'facture-paiement/{{cid}}' },
                                },
                            ],
                        },
                    },
                    {
                        text: 'Obtenir votre RIO pour le fixe',
                        link: {
                            references: [
                                {
                                    linkWeb: { inApp: 'equipements/{{cid}}/obtenir-rio-fixe' },
                                },
                            ],
                        },
                    },
                ],
                changeUniverse: {
                    sosh: {
                        label: 'Gérer sur Sosh.fr',
                        link: { inApp: '?sosh' },
                    },
                    orange: {
                        label: 'Gérer sur Orange.fr',
                        link: { inApp: '?orange' },
                    },
                },
                textRio: "Vous changez d'opérateur ?",
                textRioDetails: 'Renseignez votre RIO pour garder votre numéro actuel.',
            },
            noInformation: 'Aucune information disponible',
        },
        item: {
            title: 'Votre',
            changeMobile: 'Changer votre mobile',
        },
        picto: {
            GAUGE_RESEAU: 'icon-gauge-mon-reseau',
            OFFERS: 'icon-my-services',
            BILLS: 'icon-bill-euro',
            VOIP: 'icon-device-fixed-line-phone',
            RTC: 'icon-gauge-mon-reseau',
            INTERNET: 'icon-livebox-box',
            FEMTOCELL: 'icon-femtocell',
            SETTOPBOX: 'icon-decoder',
            PASSJEUXFAMILLE: 'icon-games',
            FLYBOX: 'icon-mobile-box',
            HOMELIVE: 'icon-Homelive',
            DEEZER_PREMIUM: 'icon-deezer-premium',
            DEEZER_FAMILLE: 'icon-deezer-family',
            EPRESS: 'icon-epress',
            IZNEO: 'icon-izneo',
            KOBOBYFNAC: 'icon-kobo',
            TVORANGE: 'icon-Orange-TV-Play',
            TVERVERYWHERE: 'icon-Collective-class-training',
            TVEVERYWHERE: 'icon-Collective-class-training',
            'CLE-TV': 'icon-La-Cle',
            CINEDAY: 'icon-2for1cinematicket',
            HORS_FORFAIT: 'icon-euro-full',
            PUSHFMO: 'icon-voucher-tag',
            DEFAULT_CONSO: 'icon-gauge-mon-reseau',
            USER_UNKNOWN: 'icon-user-unknown',
            SERVICE_24: 'icon-service-24',
            TV: 'icon-device-tv',
            TV_2: 'icon-tv-multi-room',
            'GIFT-SOSH': 'icon-rewards',
        },
        offer: 'Offre et options',
        offerLabel: 'Retrouvez votre offre en détail, ajoutez ou résiliez une option...',
        removeContract: {
            backRouteTitle: 'Retirer un contrat',
            cancel: 'Retour',
            delegation: 'Titulaire : ',
            detail: {
                delegated:
                    'Vous perdrez la procuration sur ce contrat et ne pourrez plus le gérer depuis cet Espace client, en boutique ou en service client.',
                held: "Vous pourrez le gérer et accéder à la rubrique « Votre famille » en vous connectant avec l'identifiant de ce contrat.",
                default: "Vous pourrez le gérer en vous connectant avec l'identifiant de ce contrat.",
            },
            detailTitle: 'Ne plus afficher ce contrat dans votre Espace client.',
            info: {
                logged: 'Ce contrat ne peut pas être détaché car vous êtes actuellement identifié avec celui-ci dans votre Espace client.',
                default:
                    'Si vous souhaitez afficher de nouveau ce contrat dans votre espace client, vous pourrez alors utiliser la fonctionnalité « Rattacher un contrat ».',
            },
            submit: 'Retirer ce contrat',
            title: 'Retirer ce contrat',
        },
        removeContracts: {
            delegation: 'Titulaire : ',
            info1: 'Si vous retirez un contrat, il ne sera plus visible dans votre Espace client.',
            info2: 'Il reste possible de le rattacher à nouveau ultérieurement.',
            selectionLabel: 'Sélectionnez le contrat que vous souhaitez retirer de votre Espace client :',
            title: 'Retirer un contrat',
        },
        seo: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Orange',
            logo: 'https://c.woopic.com/logo-orange.png',
            url: 'https://espace-client.orange.fr/page-accueil',
            description:
                'Gérez vos abonnements, factures, options et services en toute simplicité via votre espace client Orange. Accès sécurisé 24h/24, 7j/7..',
            contactPoint: {
                '@type': 'ContactPoint',
                telephone: '3900',
                contactType: 'Customer Service',
                name: 'Service Client Orange',
                areaServed: 'FR',
                availableLanguage: ['French', 'English'],
                hoursAvailable: [
                    {
                        '@type': 'OpeningHoursSpecification',
                        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        opens: '08:00',
                        closes: '20:00',
                    },
                ],
            },
        },
        title: 'Accueil',
        universContract: {
            mixedOrange: {
                picto: 'assets/dashboard/images/mini-logo-orange.png',
                message: 'Vous serez redirigé vers le site Orange.fr pour gérer ce contrat.',
            },
            mixedSosh: {
                picto: 'assets/dashboard/images/mini-logo-sosh.svg',
                message: 'Vous serez redirigé vers le site Sosh.fr pour gérer ce contrat.',
            },
        },
        whoUsesIt: {
            button: {
                label: 'Associer à un profil',
                link: {
                    inApp: 'compte/association-contrat/{{cid}}',
                },
                navigationExtras: {
                    queryParams: {
                        return: 'accueil',
                    },
                },
            },
            text: "Associez un profil à votre contrat pour l'identifier facilement",
        },
    },
    deviceStatus: {
        all: [
            {
                id: 'UNKNOWN',
                text: '',
                icone: '',
            },
        ],
        mlbInternetStatus: [
            {
                id: 'STANDBY_DEEP',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'STANDBY_WEAK',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'ECO_DEEP',
                text: 'Livebox arrêtée',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'ECO_WEAK',
                text: 'Mode éco activé',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'AVAILABLE',
                text: 'Internet connecté',
                icone: 'icon-tick-circle',
            },
            {
                id: 'UNAVAILABLE',
                text: 'Panne détectée',
                icone: 'icon-error-severe',
            },
            {
                id: 'UNKNOWN',
                text: '',
                icone: '',
            },
            {
                id: 'DISCONNECTED',
                text: 'Livebox déconnectée du réseau Orange',
                icone: 'icon-Warning-important',
            },
            {
                id: 'DISABLED',
                text: '',
                icone: '',
            },
        ],
        mlbWifiStatus: [
            {
                id: 'STANDBY_DEEP',
                text: '',
                icone: '',
            },
            {
                id: 'STANDBY_WEAK',
                text: '',
                icone: '',
            },
            {
                id: 'ECO_DEEP',
                text: 'Livebox arrêtée',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'ECO_WEAK',
                text: 'Mode éco activé',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'AVAILABLE',
                text: 'Wifi activé',
                icone: 'icon-tick-circle',
            },
            {
                id: 'UNAVAILABLE',
                text: 'Panne wifi détéctée',
                icone: 'icon-error-severe',
            },
            {
                id: 'UNKNOWN',
                text: '',
                icone: '',
            },
            {
                id: 'RESTRICTED',
                text: 'Wifi restreint',
                icone: 'icon-Warning-important',
            },
            {
                id: 'DISABLED',
                text: 'Wifi Désactivé',
                icone: 'icon-wifi-off',
            },
        ],
        mlbTvStatus: [
            {
                id: 'STANDBY_DEEP',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'STANDBY_WEAK',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'ECO_DEEP',
                text: 'Service TV arrêté',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'ECO_WEAK',
                text: 'Mode éco activé',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'AVAILABLE',
                text: 'Service TV activé',
                icone: 'icon-tick-circle',
            },
            {
                id: 'UNAVAILABLE',
                text: 'Panne détectée',
                icone: 'icon-error-severe',
            },
            {
                id: 'UNKNOWN',
                text: '',
                icone: '',
            },
            {
                id: 'DISABLED',
                text: '',
                icone: '',
            },
        ],
        mlbVoipStatus: [
            {
                id: 'ECO_DEEP',
                text: 'Ligne fixe arrêtée',
                icone: 'icon-Eco-mode',
            },
            {
                id: 'STANDBY_DEEP',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'STANDBY_WEAK',
                text: 'En veille',
                icone: 'icon-standby',
            },
            {
                id: 'AVAILABLE',
                text: 'Ligne connectée',
                icone: 'icon-tick-circle',
            },
            {
                id: 'UNAVAILABLE',
                text: 'Panne détectée',
                icone: 'icon-error-severe',
            },
            {
                id: 'UNKNOWN',
                text: '',
                icone: '',
            },
            {
                id: 'DISABLED',
                text: '',
                icone: '',
            },
        ],
        button: {
            label: 'Sortir du mode éco',
        },
    },
};
